/*
  media content config needs to be dynamic like duration and display mode
*/

import { Component, OnInit, OnDestroy, Input, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, Subscription } from 'rxjs';
import { ToasterService } from 'angular2-toaster';
import * as _ from 'lodash';

import { Constants } from '../../../../app.constant';
import { Campaign, PlaylistContent } from '../../../cms/components/campaign/models/campaign';
import { PreviewAlgo } from '../../../cms/components/campaign/services/campaign-preview-algo';

@Component({
  selector: 'media-preview-on-region',
  styleUrls: [('./media-preview-on-region.scss')],
  templateUrl: './media-preview-on-region.html'
})
export class MediaPreviewOnRegionComponent implements OnInit, OnDestroy, AfterViewInit {
 
  public region: any;
  public nextTime = 1;
  public loading = false;
  public contentType: string;
  public contentStyle: any={};
  public totalContent: number;
  public finalDuration: number;
  public canPause: boolean=false;
  public contentAlgorithm: any={};
  public Constants: any = Constants;
  public contentPreview: PreviewAlgo;
  public contentInterval: Subscription;
  public isAudioEnabled: boolean=false;
  public currentMediaInformation: any[];
  public previewState: string='LOADING';
  private changeCall:number = 0;  

  @Input() END: number;
  @Input() MEDIA: any[];

  private cpnVideoPlayer: ElementRef;
  @ViewChild('campaignVideoPlayer') set content(content: ElementRef) {
    this.cpnVideoPlayer = content;
  }

  constructor(
    private sanitizer: DomSanitizer,
    private _activeModal: NgbActiveModal,
    private _toasterService: ToasterService
  ) {
    // console.log('MediaPreviewOnRegion: ', this.mediaInformation);
  }

  ngOnInit(): void {
    this.playMediaInRegion();
  }

  ngAfterViewInit() { }

  async playMediaInRegion(intervalObj?:any) {
    if(this.contentInterval && !this.contentInterval.closed) {
      this.previewEnd();
      this.contentInterval.unsubscribe();
    }
    this.finalDuration = (/^[0-9]+$/.test('' + this.END)) ? parseInt('' + this.END) : 0;
    this.region = this.MEDIA;
    this.totalContent = _.get(this.region, 'globalRegionContentPlaylistContents.length', 0);
    this.isAudioEnabled = _.get(this.region, 'isAudioEnabled', false);
    this.contentPreview = new PreviewAlgo(this.region.globalRegionContentPlaylistContents, this.finalDuration, null, intervalObj);
    this.contentInterval = this.contentPreview.start()
      .subscribe((res: any) => {
        // console.log("C >> durationPassInSecond: ", res.durationPassInSecond);
        let content: PlaylistContent = res.content,
          durationPassInSecond: number=res.durationPassInSecond;
        if (!_.isEmpty(content)) {
          this.setContentInRegion(content, intervalObj, durationPassInSecond);
          this.changeCall++;
        }
      },
      (err) => {
        console.log('MediaInRegionsError: ', err);
      },
      () => {
        this.previewEnd();
        // console.log('Completed > ', this.region.layoutRegionName, this.contentPreview.debugLog);
      });
  }
  
  setContentInRegion(content:any, intervalObj?:any, durationPassInSecond?:number) {
    // reset fields.
    this.previewEnd();
    this.contentType = (content && content.contentType) ? content.contentType : content.widgetType ? content.widgetType : null;
    this.contentStyle = {};

    //content.html =  this.sanitizer.bypassSecurityTrustHtml(content.html);    

    if(content.html && (content.marqueeDirection =='up' || content.marqueeDirection =='down')){
      content.html = (typeof content.html == 'string') ? this.sanitizer.bypassSecurityTrustHtml(content.html): content.html;     
    }else if(content.html && (content.marqueeDirection =='left' || content.marqueeDirection =='right')){
      content.html = (typeof content.html == 'string') ? this.sanitizer.bypassSecurityTrustHtml(_.replace(_.replace(content.html, new RegExp('&nbsp;','g') , ' '),new RegExp('\n','g'),'&nbsp;')): content.html;     
    }
    //content.html = (typeof content.html == 'string') ? this.sanitizer.bypassSecurityTrustHtml(_.replace(_.replace(content.html, new RegExp('&nbsp;','g') , ' '),new RegExp('\n','g'),'&nbsp;')): content.html;   
    this.currentMediaInformation = content;
    if (content.displayMode == 'STRETCH-TO-FIT') {
      this.contentStyle['width'] = 'inherit';
      this.contentStyle['height'] = 'inherit';
      this.contentStyle['object-fit'] = 'fill';
    }
    else if (content.displayMode == 'NORMAL') {
      this.contentStyle['max-width'] = '100%';
      this.contentStyle['max-height'] = '100%';
    }
    switch (this.contentType) {
      case "IMAGE":
        break;
      case "VIDEO":
        // this.contentStyle.width = '100%';
        this.cpnVideoPlayerManager(content, intervalObj, durationPassInSecond);
        break;
      case "PDF":
        this.contentStyle.width = 'inherit';
        this.contentStyle.height = 'inherit';
        if (content.displayMode == 'STRETCH-TO-FIT') {
          content.sanitizerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(content.mediaUrl+'#view=FitH');
        }else{
          content.sanitizerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(content.mediaUrl);
        }
        break;
      case "AUDIO":  // not applicable
        break;
      case "RSS":
        break;
      case "TWITTER":
        break;
      case "FACEBOOK":
        break;
      case "HTML":
        break;
      case "TEXT":
        break;
      case "URL":
        // this.contentStyle.width = 'inherit';
        // this.contentStyle.height = 'inherit';
        if (content.url)
          content.sanitizerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(content.url);
        break;

      default:
     
        break;
    }
    this.previewState = 'PLAYING';
  }

  cpnVideoPlayerManager(evn: any, intervalObj?:any, durationPassInSecond?:number): void {
    if (!_.isUndefined(evn)) {
      this.canPause = false;
      let setVideoInterval: number=0;
      this.cpnVideoPlayer.nativeElement.style.display = "block";
      // this.cpnVideoPlayer.nativeElement.src = evn.mediaUrl;
      if (this.cpnVideoPlayer.nativeElement.children.length) {
        _.map(this.cpnVideoPlayer.nativeElement.children, (source: any) => {
          if (source.tagName == 'SOURCE') {
            source.src = evn.mediaUrl;
          }
          return source;
        });
        this.cpnVideoPlayer.nativeElement.load();
      }
      this.canPause = true;
      this.cpnVideoPlayer.nativeElement.muted = this.isAudioEnabled ? null : "muted";
      if (intervalObj !== undefined) {
        let setVideoInterval = this.calculateCampaignDurations(this.region.globalRegionContentPlaylistContents, intervalObj);
        this.cpnVideoPlayer.nativeElement.currentTime = setVideoInterval;
      }
      let playPromise = this.cpnVideoPlayer.nativeElement.play();  // Ref: https://stackoverflow.com/questions/37674223/domexception-failed-to-load-because-no-supported-source-was-found/40238567
      if (playPromise !== undefined) {
        playPromise.then(res => {
          // Automatic playback started!. Show playing UI.
          this.canPause = true;
        })
        .catch(error => {
          // Auto-play was prevented. Show paused UI.
          // console.warn("This video have some problem in to play.", evn, error);
        });
      }
    }
  }

  calculateCampaignDurations = function(gContent?:any, intervalObj?:any) {
    let _index: number=0,
      calculatedVal: number=0,
      durationPassInSecond: number=0,
      currentDurationInSecond: number=0,
      selectedInterval: number=intervalObj.val;
    do
    {
      _.forEach(gContent, (content)=> {
        currentDurationInSecond = content.durationInSeconds;
  
        if (
          content.contentType === "VIDEO" && 
          selectedInterval > durationPassInSecond
        ) {
          let videoInt = (selectedInterval + _index) - (durationPassInSecond);
          calculatedVal = (videoInt > 0) ? videoInt : 0;
        }
        _index++;
        durationPassInSecond = durationPassInSecond + currentDurationInSecond;
      });
    }while(calculatedVal>durationPassInSecond);
    return calculatedVal;
  }

  previewEnd() {
    this.previewState = 'ENDED';
    if (this.cpnVideoPlayer && this.cpnVideoPlayer.nativeElement) {
      // this.cpnVideoPlayer.nativeElement.style.display = "none";
      if (this.canPause == true) {
        this.cpnVideoPlayer.nativeElement.pause();
      }
    }
  }

  ngOnDestroy() {
    this.previewEnd();
    this.contentInterval.unsubscribe();
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/shared/components/media-preview-on-region/media-preview-on-region.component.ts